var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('buttons',{attrs:{"status":_vm.sortType},on:{"handleClick":_vm.handleClick}}),_c('rank-list',{attrs:{"list":_vm.list[_vm.sortType],"keys":_vm.keys[_vm.sortType],"titles":_vm.titles[_vm.sortType]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }